export function isLegacyTokenOnlyMode(url: string, enabled: boolean): boolean {
  return enabled && /^\/(?:client-tokens|configuration-ia)(?:[/?;]|$)/.test(url);
}
